"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M8.5 4A1.5 1.5 0 0 0 7 5.5v13a1.5 1.5 0 0 0 3 0v-13A1.5 1.5 0 0 0 8.5 4m7 0A1.5 1.5 0 0 0 14 5.5v13a1.5 1.5 0 0 0 3 0v-13A1.5 1.5 0 0 0 15.5 4"
}), 'Pause');
//# sourceMappingURL=index.js.map